import { gql } from '../types/generated';

export const PROVISION_MEDIA = gql(`
  mutation provisionMedia($mediaIds: [String!]!) {
    provisionMedia(mediaIds: $mediaIds) {
      mediaId
      success
      reason
    }
  }
`);

export const UNSCHEDULE_MEDIA = gql(`
  mutation unscheduleMedia($mediaIds: [String!]!) {
    unscheduleMedia(mediaIds: $mediaIds) {
      mediaId
      success
      reason
    }
  }
`);

export const START_MEDIA = gql(`
  mutation startMedia($mediaIds: [String!]!) {
    startMedia(mediaIds: $mediaIds) {
      mediaId
      reason
      success
    }
  }
`);

export const STOP_MEDIA = gql(`
  mutation stopMedia($mediaIds: [String!]!) {
    stopMedia(mediaIds: $mediaIds) {
      mediaId
      reason
      success
    }
  }
`);

export const ARCHIVE_MEDIA = gql(`
  mutation archiveMedia($mediaIds: [String!]!) {
    archiveMedia(mediaIds: $mediaIds) {
      mediaId
      reason
      success
    }
  }
`);

export const RESOLVE_ALERT = gql(`
  mutation resolveAlert($mediaId: String!, $alertId: String!) {
    resolveAlert(mediaId: $mediaId, alertId: $alertId) {
      mediaId
      success
      reason
    }
  }
`);

export const SET_EVI_STATUS = gql(`
  mutation setEviStatus($mediaId: String!, $status: PipelineEviStatus!) {
    setEviStatus(mediaId: $mediaId, status: $status) {
      mediaId
      success
      reason
    }
  }
`);

export const SYNC_MEDIA_CONTENT = gql(`
  mutation syncMediaContent($gamePk: Int!) {
   syncMediaContent(gamePk: $gamePk)
  }
`);

export const UPDATE_PIPELINE_MEDIA = gql(`
  mutation updatePipelineMedia($mediaId: String!) {
    updatePipelineMedia(mediaId: $mediaId) {
      mediaId
      success
      reason
    }
  }
`);

export const UPDATE_ASSETS_STATE = gql(`
  mutation updateAssetsState($mediaAssets: [MediaAssetsInput!]!, $assetState: AssetState!) {
    updateAssetsState(mediaAssets: $mediaAssets, assetState: $assetState) {
      mediaId
      success
      reason
    }
  }
`);

export const ACTIVATE_ADS = gql(`
  mutation activateAds($mediaId: String!, $videoId: String!) {
    activateAds(mediaId: $mediaId, videoId: $videoId)
  }
`);

export const PAUSE_ADS = gql(`
  mutation pauseAds($mediaId: String!, $videoId: String!) {
    pauseAds(mediaId: $mediaId, videoId: $videoId)
  }
  `);

export const CREATE_MULTICAST_MAPPING = gql(`
  mutation createMulticastMapping($callSign: String!, $priority: String!, $sourceLocation: String!, $multicastAddress: String!, $hdrMulticastAddress: String) {
    createMulticastMapping(callSign: $callSign, priority: $priority, sourceLocation: $sourceLocation, multicastAddress: $multicastAddress, hdrMulticastAddress: $hdrMulticastAddress) {
      ...MulticastMappingFields
    }
  }
`);

export const UPDATE_MULTICAST_MAPPING = gql(`
  mutation updateMulticastMapping($id: Int!, $updatedMapping: MulticastMappingUpdateRequest!) {
    updateMulticastMapping(id: $id, updatedMapping: $updatedMapping) {
      ...MulticastMappingFields
    }
  }
`);

export const DELETE_MULTICAST_MAPPING = gql(`
  mutation deleteMulticastMapping($id: Int!) {
    deleteMulticastMapping(id: $id)
  }
`);

export const ASSIGN_EVI_POD = gql(`
  mutation assignEviPod($mediaId: String!, $eviPodName: String!) {
    assignEviPod(mediaId: $mediaId, eviPodName: $eviPodName) {
      mediaId
      success
      reason
    }
  }
`);

export const PROVISION_COPYRIGHT_STREAM = gql(`
  mutation provisionCopyrightStream($stream: CopyrightStreamProvision!) {
    provisionCopyrightStream(stream: $stream) {
      ...CopyrightStreamFields
    }
  }
`);

export const START_COPYRIGHT_STREAM = gql(`
  mutation startCopyrightStream($streamId: String!) {
    startCopyrightStream(streamId: $streamId) {
      ...CopyrightStreamFields
    }
  }
`);

export const STOP_COPYRIGHT_STREAM = gql(`
  mutation stopCopyrightStream($streamId: String!) {
    stopCopyrightStream(streamId: $streamId) {
      ...CopyrightStreamFields
    }
  }
`);

export const DELETE_COPYRIGHT_STREAM = gql(`
  mutation deleteCopyrightStream($streamId: String!) {
    deleteCopyrightStream(streamId: $streamId)
  }
`);

export const UPDATE_CDN_STATUS = gql(`
  mutation updateCdnStatus($cdn: Cdn!, $enabled: Boolean!) {
    updateCdnStatus(cdn: $cdn, enabled: $enabled)
  }
`);

export const UPDATE_BROADCAST = gql(`
  mutation updateBroadcast(
    $mediaId: String!
    $mediaState: MediaState
    $freeGameStatuses: [FreeGameStatusInput!]
    $availableForStreaming: Boolean
    $videoResolution: VideoResolution
    $colorSpace: VideoColorSpace
    $mvpdRequired: Boolean
  ) {
    updateBroadcast(
      mediaId: $mediaId
      mediaState: $mediaState
      freeGameStatuses: $freeGameStatuses
      availableForStreaming: $availableForStreaming
      videoResolution: $videoResolution
      colorSpace: $colorSpace
      mvpdRequired: $mvpdRequired
    ) {
      mediaId
      success
      reason
    }
  }
`);

export const UPDATE_BROADCAST_SOURCE = gql(`
  mutation updateBroadcastSource(
    $gamePk: Int!,
    $feedType: MediaFeedType!,
    $sourceUpdateInput: BroadcastSourceUpdateInput!
  ) {
    updateBroadcastSource(
      gamePk: $gamePk,
      feedType: $feedType,
      sourceUpdateInput: $sourceUpdateInput
    )
  }
`);

export const SWITCH_PROGRAM_SOURCE = gql(`
  mutation switchProgramSource($mediaIds: [String!]!, $programSource: ProgramSource!) {
    switchProgramSource(mediaIds: $mediaIds, programSource: $programSource) {
      mediaId
      success
      reason
    }
  }
`);

export const CREATE_BROADCAST_SOURCE_OVERRIDE = gql(`
  mutation createBroadcastSourceOverride(
    $broadcastSourceOverrideInput: BroadcastSourceOverrideInput!
  ) {
    createBroadcastSourceOverride(
        broadcastSourceOverrideInput: $broadcastSourceOverrideInput
    ) {
      id
      callSign
      pregameSource
      gameSource
      postgameSource
    }
  }
`);

export const DELETE_BROADCAST_SOURCE_OVERRIDE = gql(`
  mutation deleteBroadcastSourceOverride (
    $id: Int!
  ) {
    deleteBroadcastSourceOverride(
      id: $id
    )
  }
`);

export const UPDATE_BROADCAST_SOURCE_OVERRIDE = gql(`
  mutation updateBroadcastSourceOverride (
    $id: Int!
    $broadcastSourceOverrideInput: BroadcastSourceOverrideInput!
  ) {
    updateBroadcastSourceOverride(
      id: $id
      broadcastSourceOverrideInput: $broadcastSourceOverrideInput
    ) {
      id
      callSign
      pregameSource
      postgameSource
      gameSource
    }
  }
`);

export const CREATE_BROADCAST_OVERRIDE = gql(`
  mutation createBroadcastOverride (
    $gamePk: Int!, $feedTypeCode: String!,
    $region: String!
    $callSign: String!
    $fronthaulDecoderInputLabel: String
    $multicastAddress: String) {
      createBroadcastOverride(
        gamePk: $gamePk,
        feedTypeCode: $feedTypeCode,
        region: $region,
        callSign: $callSign,
        fronthaulDecoderInputLabel: $fronthaulDecoderInputLabel,
        multicastAddress: $multicastAddress
      ) {
        id,
        region,
        callSign,
        fronthaulDecoderInputLabel,
        multicastAddress
      }
  }
`);

export const UPDATE_BROADCAST_OVERRIDE = gql(`
  mutation updateBroadcastOverride (
    $id: Int!
    $region: String!
    $updatedBroadcastOverride: BroadcastOverrideUpdateRequest!
  ) {
    updateBroadcastOverride(
      id: $id,
      region: $region,
      updatedBroadcastOverride: $updatedBroadcastOverride
    ) {
      id
      region
      callSign
      fronthaulDecoderInputLabel
      multicastAddress
    }
  }
`);

export const DELETE_BROADCAST_OVERRIDE = gql(`
  mutation deleteBroadcastOverride ($id: Int!, $region: String!) {
    deleteBroadcastOverride(id: $id, region: $region)
  }
`);

export const UPDATE_PARTNER_DISTRIBUTION_LOCK = gql(`
  mutation updatePartnerDistributionLock ($teamId: Int!, $setLock: Boolean!) {
    updatePartnerDistributionLock(teamId: $teamId, setLock: $setLock)
  }
`);

export const TOGGLE_SKYVIEW_CONFIG = gql(`
  mutation toggleSkyviewConfig($teamId: Int!, $language: String!, $enabled: Boolean!) {
    toggleSkyviewConfig(teamId: $teamId, language: $language, enabled: $enabled) {
      teamId
      language
      enabled
    }
  }
`);

export const TOGGLE_ALL_SKYVIEW_CONFIGS = gql(`
  mutation toggleAllSkyviewConfigs($enabled: Boolean!) {
    toggleAllSkyviewConfigs(enabled: $enabled)
  }
`);

export const INGEST_ASSETS_INTO_DAI = gql(`
  mutation ingestAssetsIntoDai($assetIds: [Int!]!) {
    ingestAssetsIntoDai(assetIds: $assetIds)
  }
`);
